module.exports = __webpack_public_path__ + "media/application/images/icons/filter-arrow-3cb6a7d2e21b42a84337017d8d3b83ef.svg";